import { useState } from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

interface Props {
  transactionId: string;
}

const TRUNCATE_LENGTH = 8;
const FEEDBACK_MS = 2000;

/**
 * H5: ID truncado a los primeros 8 caracteres + "…" con copy-to-clipboard del ID
 * completo y confirmación visual breve. stopPropagation: copiar no abre el drawer.
 */
function TransactionIdCell({ transactionId }: Readonly<Props>) {
  const [copied, setCopied] = useState(false);

  const truncated =
    transactionId && transactionId.length > TRUNCATE_LENGTH
      ? `${transactionId.slice(0, TRUNCATE_LENGTH)}…`
      : transactionId || '—';

  const handleCopy = async (event: React.MouseEvent) => {
    event.stopPropagation();
    if (!transactionId) return;
    try {
      await navigator.clipboard.writeText(transactionId);
      setCopied(true);
      setTimeout(() => setCopied(false), FEEDBACK_MS);
    } catch {
      // clipboard no disponible (permisos/contexto): no rompemos la fila
    }
  };

  return (
    <>
      <Typography fontSize={16} whiteSpace="nowrap">
        {truncated}
      </Typography>
      {transactionId && (
        <Tooltip title={copied ? 'Copiado' : 'Copiar ID completo'}>
          <IconButton size="small" aria-label="copiar id" onClick={handleCopy}>
            {copied ? <CheckIcon fontSize="inherit" /> : <ContentCopyIcon fontSize="inherit" />}
          </IconButton>
        </Tooltip>
      )}
    </>
  );
}

export default TransactionIdCell;
